import Head from "next/head"

export const Preloader = (props) => {
  return (
    <>
      <Head>
        <link
          rel="canonical"
          href={"https://przyjazne-deklaracje.pl/" + props.redirect}
        />
        <meta
          http-equiv="refresh"
          content={
            "0; " + "url=https://przyjazne-deklaracje.pl/" + props.redirect
          }
        />
      </Head>
      <section className="pd-preloader">
        <img
          className="pd-prealoader__image"
          src="https://przyjazne-deklaracje.pl/resources/images/icons/general/preloader/preloader.svg"
          alt="Ładowanie strony internetowej"
        />
      </section>
    </>
  )
}
